import { Box, Typography } from "@mui/material";

const InlineLabeledText = ({label, value, labelProps, valueProps, my}: any) => <Box sx={{whiteSpace: 'nowrap'}} my={my === undefined? 1: my}>
    <Typography noWrap display="inline" fontWeight="bold" {...labelProps}>{label}:</Typography>{' '}
    <Typography noWrap display="inline" {...valueProps}>{value}</Typography>
</Box>

export default InlineLabeledText;